<template>
  <div :class="['edmodo-footer', isLoading ? 'isLoading' : 'isLoaded']">
    <footer class="fusion-footer-widget-area fusion-widget-area">
      <div class="fusion-row">
        <lang />
        <div class="footer-links">
          <column v-for="(column, index) in columns" :title="column.title" :links="column.links" :key="index"></column>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import Column from './footer/column'
import Lang from './footer/lang'
import * as Edmodo from '../../constants/edmodo'
export default {
  name: 'edmodoFooter',
  components: {
    Column,
    Lang
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      columns: [
        {
          title: this.$t('txt_0039'),
          links: [
            {
              title: this.$t('txt_0040'), // about
              url: Edmodo.ABOUT
            },
            {
              title: this.$t('txt_0041'), // careers
              url: Edmodo.CAREERS
            },
            {
              title: this.$t('txt_0042'), // privacy
              url: Edmodo.PRIVACY,
              event_id: 'edmodolabs_web_privacy001001'
            },
            {
              title: this.$t('txt_0043'), // terms of service
              url: Edmodo.TERMS_OF_SERVICE,
              event_id: 'edmodolabs_web_service001001'
            },
            {
              title: this.$t('txt_0044'), // contact us
              url: Edmodo.CONTACT_OF_US
            }
          ]
        },
        {
          title: this.$t('txt_0045'),
          links: [
            {
              title: this.$t('txt_0046'),
              url: Edmodo.TEACHERS
            },
            {
              title: this.$t('txt_0047'),
              url: Edmodo.STUDENTS
            },
            {
              title: this.$t('txt_0048'),
              url: Edmodo.PARENTS
            },
            {
              title: this.$t('txt_0049'),
              url: Edmodo.SCHOOLS
            }
          ]
        },
        {
          title: this.$t('txt_0050'),
          links: [
            {
              title: this.$t('txt_0051'),
              url: Edmodo.SPOTLIGHT
            },
            {
              title: this.$t('txt_0052'),
              url: Edmodo.BLOG
            },
            {
              title: this.$t('txt_0053'),
              url: Edmodo.SUPPORT
            }
          ]
        },
        {
          title: this.$t('txt_0054'),
          links: [
            {
              title: this.$t('txt_0055'),
              url: Edmodo.TWITTER
            },
            {
              title: this.$t('txt_0056'),
              url: Edmodo.FACEBOOK
            }
          ]
        }
      ]
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    init () {

    }
  }
}
</script>

<style scoped>
.edmodo-footer {
  width: 1440px; /*no*/
  max-width: 1400px; /*no*/
  background-color: #ffffff;
  border-color: #e0e0e0;
  border-top-width: 1px; /*no*/
  padding: 30px 20px 20px;  /*no*/
}
.isLoaded {
  margin: 0 auto;
}
.isLoading {
  position: fixed;
  bottom: 0;
  left: 50%;
  margin-left: -720px; /*no*/
}
footer {
  width: 100%;
}
.fusion-footer-widget-area {
  color: #777777;
}
.fusion-footer-widget-area {
  border-color: #333333;
  border-top-width: 2px; /*no*/
}
.fusion-footer-widget-area {
  overflow: hidden;
  position: relative;
  color: #8c8989;
  backface-visibility: hidden;
}
.fusion-row {
  max-width: 1440px; /*no*/
  box-sizing: border-box;
  margin: 0 auto;
  zoom: 1;
  overflow: hidden;
}
@media only screen and ( max-width: 768px) {
  .edmodo-footer {
    width: 100%;
    border-top-width: 1px;
    padding: 30px 20px 20px;
  }
  .isLoading {
    left: 0;
    margin: 0;
  }
  .fusion-footer-widget-area {
    border-top-width: 2px;
  }
  .fusion-row {
    max-width: 100%;
  }
  .footer-links {
    display: flex;
    display: -webkit-flex;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// footer.vue?4c34b4de